import React from 'react'
import Logo from '../../../../../App/assets/images/logoPrimaOrange.svg'
import { ContainerHeader } from './style'
import { useStateDigitalTransfersContext } from '../../../../../digital-transfers/context/DigitalTransfersContext';

export const Header = () => {
    const { stepCurrent } =
        useStateDigitalTransfersContext();
    return (
        <ContainerHeader>
            <div>
                <div
                    id="btn-identity-back">
                    <img
                        src={Logo}
                        alt="logo PRIMA"
                        className="primaLogoStep0"
                        style={{ cursor: "pointer" }}
                    />

                </div>
            </div>
            <div className="text">Ayer. Hoy. Siempre</div>
        </ContainerHeader>
    )
}
